import { useEffect, useState } from 'react';
import { useDebouncedValue } from '@mantine/hooks';
import {
  QueryBuilderEntityConfigType,
  QueryBuilderEntityValueOptionType,
  QueryBuilderInputContextType,
} from '../../../../types';

type UseEntityValueOptionsArgsType = {
  context: QueryBuilderInputContextType;
  pendingEntity: QueryBuilderEntityConfigType | null;
  search: string;
};

type UseEntityValueOptionsReturnType = {
  valueOptions: QueryBuilderEntityValueOptionType[];
  isLoadingValues: boolean;
};

export const useEntityValueOptions = ({
  context,
  pendingEntity,
  search,
}: UseEntityValueOptionsArgsType): UseEntityValueOptionsReturnType => {
  const [debouncedSearch] = useDebouncedValue(search, 300);
  const [valueOptions, setValueOptions] = useState<
    QueryBuilderEntityValueOptionType[]
  >([]);
  const [isLoadingValues, setIsLoadingValues] = useState(false);

  useEffect(() => {
    if (context !== 'expectValue' || !pendingEntity) {
      setValueOptions([]);
      setIsLoadingValues(false);
      return undefined;
    }

    let cancelled = false;
    setIsLoadingValues(true);

    pendingEntity
      .loadValues(debouncedSearch)
      .then((options: QueryBuilderEntityValueOptionType[]) => {
        if (!cancelled) {
          setValueOptions(options);
          setIsLoadingValues(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setValueOptions([]);
          setIsLoadingValues(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [context, pendingEntity, debouncedSearch]);

  return {
    valueOptions,
    isLoadingValues,
  };
};
